import React, { useMemo } from 'react';
import ThemeContext from '../../context/themeContext';
import { getTheme } from '../../context/themeContext/themes';
import { getAffiliateDetails, getAffiliate } from '../../utils/appUtils';
import browserUtils from '../../utils/browserUtils';

import './style.scss';

export default ({ children }) => {
  const aff = getAffiliate();

  const updateThemeIsCSS = theme => {
    const root = document.querySelector(':root');

    const { colors, font, radius, cards, detailsPage, topNav, thankyouPage, reviewPage } = theme;

    if (colors?.button?.primary?.bg) {
      root.style.setProperty('--color-btn-primary-bg', colors.button.primary.bg);
      root.style.setProperty('--color-btn-primary-border', colors.button.primary.border);
      root.style.setProperty('--color-btn-primary-color', colors.button.primary.color);
      root.style.setProperty('--color-btn-primary-bg2', colors.button.primary.bg2);
    }
    root.style.setProperty('--color-btn-updateBtn-bg', colors.button.updateBtn.bg);

    root.style.setProperty('--color-text-primary', colors.text.primary);
    root.style.setProperty('--color-btn-secondary-bg', colors.button.secondary.bg);
    root.style.setProperty('--color-btn-secondary-text', colors.button.secondary.text);
    root.style.setProperty('--color-btn-top-nav-bg', colors.button.topNav.bg);
    root.style.setProperty('--color-btn-top-nav-text', colors.button.topNav.text);
    root.style.setProperty('--color-btn-top-nav-text', colors.button.topNav.text);

    root.style.setProperty('--color-label-primary', colors.label.primary);
    root.style.setProperty('--color-label-secondary', colors.label.secondary);

    root.style.setProperty('--color-link-secondary', colors.link.secondary);

    root.style.setProperty('--color-top-nav', colors.topNav);

    root.style.setProperty('--color-overlay-top-nav-form', colors.overlays.topNavForm);

    root.style.setProperty('--color-body-bg', colors.bodyBG);
    root.style.setProperty('--color-body-bg-listing', colors.bodyBGListing);
    root.style.setProperty('--color-explore-links', colors.exploreLinksColor);

    root.style.setProperty('--color-top-nav-input', colors.topnavInput);

    if (colors?.topnavInputPlaceholder) {
      root.style.setProperty('--color-top-nav-input-placeholder', colors.topnavInputPlaceholder);
    }

    if (colors?.topnavBtnShimmer) {
      root.style.setProperty('--color-top-nav-btn-shimmer', colors.topnavBtnShimmer);
    }

    root.style.setProperty('--font-size-base-lg', font.size.main.lg);
    root.style.setProperty('--font-size-base-md', font.size.main.md);
    root.style.setProperty('--font-size-base-sm', font.size.main.sm);
    root.style.setProperty('--font-size-base-xl', font.size.main.xl);
    root.style.setProperty('--font-size-btn-xl', font.size.button.xl);
    root.style.setProperty('--font-size-btn-lg', font.size.button.lg);
    root.style.setProperty('--font-size-btn-md', font.size.button.md);
    root.style.setProperty('--font-size-btn-sm', font.size.button.sm);
    root.style.setProperty('--font-size-heading', font.size.heading);
    root.style.setProperty('--font-size-sub-heading', font.size.subHeading);
    root.style.setProperty('--font-size-page-header', font.size.pageHeader);
    root.style.setProperty('--font-weight', font.weight);

    root.style.setProperty('--radius-btn-top-nav', radius.button.topNav);
    root.style.setProperty('--radius-btn-primary', radius.button.primary);
    root.style.setProperty('--radius-btn-secondary', radius.button.secondary);

    // cards specific styles
    root.style.setProperty('--card-package-type-font-size', cards.packageType.fontSize);
    root.style.setProperty('--card-package-name-font-size', cards.packageName.fontSize);
    root.style.setProperty('--card-dest-info-font-size', cards.destinationInfo.fontSize);
    root.style.setProperty('--card-d-n-info-color', cards.dayNightInfoLabel.color);
    root.style.setProperty('--card-d-n-info-bg-color', cards.dayNightInfoLabel.bgColor);
    root.style.setProperty('--card-includes-font-size', cards.includes.fontSize);
    root.style.setProperty('--card-sight-seeing-font-size', cards.sightSeeing.fontSize);
    root.style.setProperty('--card-actual-price-font-size', cards.priceActual.fontSize);
    root.style.setProperty('--card-current-price-font-size', cards.priceCurrent.fontSize);
    root.style.setProperty('--card-bottom-info-font-size', cards.bottomInfoSection.fontSize);
    root.style.setProperty('--card-badge-font-size', cards.badge.fontSize);
    root.style.setProperty('--card-badge-color', cards.badge.color);
    root.style.setProperty('--card-badge-bg-color', cards.badge.bgColor);

    /* Top Nav global variables */
    root.style.setProperty('--topnav-input-wrap-border-color', topNav.inputContainerBorder);

    /* Details Page variables */

    const { leftContainer, mainNav, itineraryNav, dayplan, rightContainer } = detailsPage;
    // left section
    root.style.setProperty('--details-left-section-box-shadow', leftContainer.boxShadow);

    // Main Nav
    root.style.setProperty('--details-main-nav-font-size', mainNav.fontSize);
    root.style.setProperty('--details-main-nav-font-weight', mainNav.fontWeight);

    // Itinerary nav
    if (itineraryNav?.tab?.active?.border) {
      root.style.setProperty(
        '--details-itinerary-tab-active-border',
        itineraryNav.tab.active.border
      );
    }
    root.style.setProperty('--details-itinerary-nav-margin-bottom', itineraryNav.marginBottom);
    root.style.setProperty('--details-itinerary-nav-bg-color', itineraryNav.bgColor);
    root.style.setProperty('--details-itinerary-tab-color', itineraryNav.tab.color);
    root.style.setProperty('--details-itinerary-tab-bg-color', itineraryNav.tab.bgColor);
    root.style.setProperty('--details-itinerary-tab-active-color', itineraryNav.tab.active.color);
    root.style.setProperty(
      '--details-itinerary-tab-active-bg-color',
      itineraryNav.tab.active.bgColor
    );
    root.style.setProperty('--review-bg-color', reviewPage.bgColor);
    root.style.setProperty('--review-top-header-nav-color', reviewPage.navColor);

    // Dayplan
    const { flightUpgradeRow } = dayplan;
    root.style.setProperty('--details-dayplan-bg-color', dayplan.bgColor);
    root.style.setProperty('--details-dayplan-title-bg', dayplan.title.bg);
    root.style.setProperty('--details-dayplan-title-bg2', dayplan.title.bg2);
    root.style.setProperty('--details-dayplan-title-color', dayplan.title.color);
    root.style.setProperty('--details-dayplan-flight-upgrade-bg', flightUpgradeRow.bg);
    root.style.setProperty('--details-dayplan-flight-upgrade-margin', flightUpgradeRow.margin);
    root.style.setProperty(
      '--details-dayplan-flight-upgrade-border-radius',
      flightUpgradeRow.borderRadius
    );

    // Right Section
    const { topHeader } = rightContainer;
    root.style.setProperty('--details-right-section-header-bg', topHeader.bg);
    root.style.setProperty('--details-right-section-header-badge-bg', topHeader.badge.bg);

    root.style.setProperty('--thankyou-top-header-color', thankyouPage.topHeaderColor);
    root.style.setProperty('--thankyou-successful-booking-color', thankyouPage.bg);
  };

  const [theme, affiliateDetails] = useMemo(() => {
    if (aff) {
      const theme = getTheme(aff);
      const affiliateDetails1 = getAffiliateDetails();
      updateThemeIsCSS(theme);
      browserUtils.changeFavicon(theme.images.favicon);
      return [theme, affiliateDetails1];
    }
  }, [aff]);

  return (
    <ThemeContext.Provider value={{ theme, affiliateDetails }}>
      <div className="theme-wrapper">{children}</div>
    </ThemeContext.Provider>
  );
};
